import { useEffect } from 'react';
import ContainerComponent from '@/components/common/notes/show-note-forms/form-components/container-component';
import { SET_VALUE } from '@/components/common/notes/show-note-forms/dataToSendReducer';
import TextField from '@mui/material/TextField';

interface Props {
    value: string;
    formId: string;
    formName: string;
    formDispatch: any;
    autoFocus?: boolean;
    dataTestSc: string;
    item: {
        label: string;
        name: string;
        placeholder: string;
        subtype: string;
        required: boolean;
        type: string;
        description: string;
    };
    readOnly: boolean;
}

const TextFieldComponent = ({
    value,
    formDispatch,
    formId,
    formName,
    autoFocus,
    item: { label, name: fieldId, placeholder, required, description },
    dataTestSc,
    readOnly,
}: Props) => {
    useEffect(() => {
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId } });
        formDispatch({ type: SET_VALUE, payload: { value, fieldId, formId: formName } });
    }, []);

    return (
        <ContainerComponent label={label} required={required} description={description}>
            <TextField
                sx={{
                    width: '100%',
                    fontFamily: "'Google Sans',Roboto,Arial,sans-serif",
                    fontSize: 14,
                }}
                placeholder={placeholder}
                value={value}
                autoFocus={autoFocus}
                data-test-sc={dataTestSc}
                disabled={readOnly}
                size='small'
            />
        </ContainerComponent>
    );
};

export default TextFieldComponent;
